// AI Generated Test
import { Component, Input } from '@angular/core';

@Component({
    selector: 'seo-information-quick-help',
    standalone: false,
    template: `
        <div class="row">
            <div class="col-lg-48 px-6">
                <h4 class="pb-4"><span class="text-primary" translate>How to fix this problem</span></h4>
                <quick-help-translations [seoName]="seo.translation_name"></quick-help-translations>
            </div>
        </div>
    `,
})
export class SeoInformationQuickHelpComponent {
    @Input() seo: any;
}
